<template>
  <div>
    <div class="contentBox" v-loading="loading">
      <div style="text-align: right; margin-bottom: 20px" v-show="pictureList.length">
        <el-button type="primary" size="small" icon="el-icon-check" @click="handleCheckAllChange">全选</el-button>
        <el-button class="orange-btn" size="small" icon="el-icon-download" @click="download(1)">下载</el-button>
      </div>
      <div class="imgBox">
        <el-checkbox-group v-model="checkedCities" @change="checkChange">
          <div style="display: flex; flex-wrap: wrap">
            <div
              v-for="(item, index) in pictureList.slice((this.pageNum - 1) * this.pageSize, this.pageSize * this.pageNum)"
              :key="item.dataId"
              :style="`width: 32%; height: calc(50% - 10px);overflow:hidden; margin:${
                index == 1 || index % 3 == 1 ? '0px 10px 10px 10px' : '0px 0px 10px 0px'
              }`"
            >
              <div class="checkbox-item">
                <el-checkbox :label="item">
                  <div class="checkBox">
                    <el-image style="width: 100%; height: 100%" :src="item.filePath" fit="scale-down"></el-image>
                  </div>
                </el-checkbox>
              </div>
            </div>
          </div>
        </el-checkbox-group>
        <div style="font-family: PingFangSC" v-show="historyList.length">
          <span>往期图片</span>
          <el-button type="text" @click="collapseClick">
            {{ isCollapse ? "收起" : "展开" }}
            <i :class="[isCollapse ? 'el-icon-arrow-left' : 'el-icon-arrow-right']"></i>
          </el-button>
          <div v-show="isCollapse">
            <div style="text-align: right; margin-bottom: 20px" v-show="historyList.length">
              <!-- <el-button type="primary" size="small" icon="el-icon-check" @click="handleCheckAllBelowChange">全选</el-button>
              <el-button class="orange-btn" size="small" icon="el-icon-download" @click="download(2)">下载</el-button> -->
            </div>
            <el-checkbox-group v-model="checkedBelowCities" @change="checkChange">
              <div style="display: flex; flex-wrap: wrap">
                <div
                  v-for="(item, index) in historyList.slice((this.pageNum - 1) * this.pageSize, this.pageSize * this.pageNum)"
                  :key="item.dataId"
                  :style="`width: 32%; height: calc(50% - 10px);overflow:hidden; margin:${
                    index == 1 || index % 3 == 1 ? '0px 10px 10px 10px' : '0px 0px 10px 0px'
                  }`"
                >
                  <div class="checkbox-item">
                    <el-checkbox :label="item">
                      <div class="checkBox">
                        <el-image style="width: 100%; height: 100%" :src="item.filePath" fit="scale-down"></el-image>
                      </div>
                    </el-checkbox>
                  </div>
                </div>
              </div>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div style="height:180px" v-if="loading"></div>
    </div>
    <!-- <div height="auto" style="text-align: right; margin-top: 10px">
      <el-pagination
        @size-change="onSizeChange"
        @current-change="onCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 15, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div> -->
  </div>
</template>
<script>
import { Checkbox } from "element-ui";
import JSZip, { forEach } from "jszip";
import FileSaver from "file-saver";
import axios from "@/utils/axiosInstance";
export default {
  props: {
    rowData: {
      type: Object,
      default: () => {},
    },
    dialogTitle: {
      type: String,
      default: () => "",
    },
  },
  watch: {
    pictureList(ov, nv) {
      console.log(ov);
    },
  },
  computed: {
    imgAllList() {
      return  this.isCollapse ? [...this.pictureList,...this.historyList] : this.pictureList
    },
    checkAllList() {
      return this.isCollapse ? [...this.checkedCities,...this.checkedBelowCities] : this.checkedCities
    }
  },
  created() {
    this.init();
    // this.total = this.pictureList ? this.pictureList.length : 0;
  },
  data() {
    return {
      loading: false,
      loadingAll: false,
      dialogImageUrl: "",
      dialogVisible: false,
      checkedCities: [],
      checkedBelowCities: [],
      checkAll: false,
      checkAllBelow: false,
      rules: {
        size: [{ required: true, message: "请选择后在进行下载", trigger: "blur" }],
      },
      filePathList: [],
      errorNum: 0,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      isCollapse: false,
      pictureList: [],
      historyList: [],
    };
  },
  methods: {
    init() {
      let data = {
        categoryType: this.dialogTitle,
        productName: this.rowData.productName,
        processType: this.rowData.processType,
        parentFolderName: this.rowData.parentFolderName,
      };
      this.loading = true;
      this.$q.newProduct
        .pictureDetail({ data: data })
        .then((res) => {
          if (res.code == 200) {
            let { pictureList, historyList } = res.data || {};
            this.pictureList = pictureList || [];
            this.historyList = historyList || [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCheckAllChange() {
      this.checkAll = !this.checkAll;
      if (this.checkAll) {
        this.checkedCities = this.pictureList;
        if(this.isCollapse){
          this.checkedBelowCities = this.historyList;
        }
      } else {
        this.checkedCities = [];
        if(this.isCollapse){
          this.checkedBelowCities = [];
        }
      }
    },
    collapseClick() {
      this.isCollapse = !this.isCollapse
      this.checkChange()
    },
    checkChange(val) {
      if (this.checkAllList.length == this.imgAllList.length && this.checkAllList.length > 0) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    handleCheckAllBelowChange() {
      this.checkAllBelow = !this.checkAllBelow
      if (this.checkAllBelow) {
        this.checkedBelowCities = this.historyList;
      } else {
        this.checkedBelowCities = [];
      }
    },
    checkBelowChange(val) {
      if (val.length == this.historyList.length && val.length && val.length > 0) {
        this.checkAllBelow = true;
      } else {
        this.checkAllBelow = false;
      }
    },
    download(type) {
      let downloadList = this.checkAllList
      if (!downloadList.length) {
        this.$message.error("请选择对应文件后在进行操作");
        return;
      }
      this.loadingAll = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      downloadList.forEach((item, index) => {
        setTimeout(() => {
          this.downloadRes(item.filePath, item.fileName, index);
        }, 200 * index);
      });
    },

    onSizeChange(pageSize) {
      this.pageNum = 1;
      this.pageSize = pageSize;
    },

    onCurrentChange(pageNum) {
      this.pageNum = pageNum;
    },

    downloadConfirm() {},
    async downloadRes(url, fileName, index) {
      let response = await fetch(url, { mode: "cors" });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = objectUrl;
      a.download = fileName + "" + url.substring(url.lastIndexOf("."));
      a.click();
      a.remove();
      if (index + 1 == this.checkedCities.length) {
        this.loadingAll.close();
      }
    },
    async downloadResBlob(url, fileName) {
      let response = await fetch(url, { mode: "cors" });
      let blob = await response.blob();
      return blob;
    },
  },
};
</script>

<style lang="stylus" scoped>

.contentBox {
  max-height: 70vh
  overflow-y: auto;
}

.checkBox {
  width: 100%;
  height: 149px;
  margin: 10px 10px 0 0;
  overflow: hidden;
  border-radius: 6px;
}

form >>> .el-form-item {
  display: flex;
  align-items: center;
}

form >>> .el-form-item__content {
  margin-left: 10px !important;
}

strong {
  color: #333333;
  font-weight: 500;
  font-family: PingFangBold;
}

.el-icon-check {
  color: #0BB78E !important;
}

.text {
  color: #999999 !important;
  font-family: PingFangSC;
  font-size: 13px;

  &::after {
    content: '';
    margin-right: 10px;
  }
}

.el-icon-more {
  line-height: 24px;
  font-size: 13px;
  color: #666666;
}

.popperText {
  color: #666666;
  font-family: PingFangSC;
  font-size: 13px;
  font-weight: 400;

  &::before {
    content: '';
    margin-left: 5px;
  }
}

>>> .el-checkbox__input{
  position: relative;
  top: -137px;
}

>>> .el-checkbox {
  width: 100%
}

>>> .el-checkbox__label {
  width: calc(100% - 30px)
}
</style>
<style scoped>
/* @media screen and (min-width: 1920px) {
  .imgBox {
    max-height: 650px;
    overflow-y: auto;
  }
}

@media screen and (max-width: 1500px) {
  .imgBox {
    max-height: 335px;
    overflow-y: auto;
  }
} */
</style>
